import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { Mr2, UnderlineDecoration, Mr1 } from 'wrappers';
import { SecondaryTextSm, Empty } from 'atoms';
import { ImageSvg } from 'components/icons';
import getIsMobile from "components/atoms/utils/getIsMobile";

const isMobile = getIsMobile();

const template = styled.label`
  ${({ isHovered }) => css`
    height: ${isHovered ? '60px' : '43px'};
    min-width: 250px;
    width: 100%;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    border: ${isHovered ? `1px solid ${window?.settings?.primary_color ?? '#1DBD6B'}` : 'unset'};
    border-radius: 8px;  
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23E3E3E3' strokeWidth='2' stroke-dasharray='10%2c 10' stroke-dashoffset='30' strokeLinecap='square'/%3e%3c/svg%3e");
    cursor: pointer;
    padding-left: 16px;

    &:hover {
      border: 1px solid ${window?.settings?.primary_color ?? '#1DBD6B'};
      background-image: unset;
    }

    @media only screen and (min-width: 768px) {
      justify-content: center; 
      padding-left: unset;
    }
  `}
`;

export default Molecule({
  template,
  type: 'dropFiles',
  atoms: [
    {
      component: wrap(Empty, Mr2),
      name: 'Icon',
      displayValue: ({ }) => ImageSvg({})
    },
    {
      component: wrap(SecondaryTextSm, Mr1),
      name: 'SecondText',
      renderIf: ({ }) => !isMobile,
      displayValue: ({ }) => 'Drag and drop or'
    },
    {
      component: wrap(wrap(SecondaryTextSm, Mr1), UnderlineDecoration),
      name: 'UploadButton',
      renderIf: ({ }) => !isMobile,
      displayValue: ({ }) => 'browse',
    },
    {
      component: SecondaryTextSm,
      name: 'ThirdText',
      renderIf: ({ }) => !isMobile,
      displayValue: ({ }) => 'to add images or videos'
    },
    {
      component: SecondaryTextSm,
      name: 'ThirdText',
      renderIf: ({ }) => isMobile,
      displayValue: ({ }) => 'Add images and videos'
    }
  ]
})